import AllBenefitsButton from './AllBenefitsButton'

export default AllBenefitsButton
